﻿import { createApp } from 'vue';
import SoftoolsSignalrClient from './SoftoolsSignalrClient.vue';

const app = createApp(SoftoolsSignalrClient);

app.mount('#toast-container');
